import { useMemo } from 'react';
import { VisAuthService } from '@vis-auth/react';
import getAuthConfig from '../utils/getAuthConfig';
import { useEnvironment } from '../context/Environment/EnvironmentContext';

const useVisAuthService = (): VisAuthService => {
  const { AUTH_CLIENTID, LOGIN_DOT_GOV_URL, LOGIN_DOT_GOV_AUTH_CLIENTID } = useEnvironment();
  const configuration = getAuthConfig(AUTH_CLIENTID, LOGIN_DOT_GOV_AUTH_CLIENTID, LOGIN_DOT_GOV_URL);
  const service = useMemo(() => new VisAuthService(configuration), [configuration]);

  return service;
};

// Creates a VisAuthService using loginDotGov configurations
export const useLoginDotGovVisAuthService = (): VisAuthService => {
  const { AUTH_CLIENTID, LOGIN_DOT_GOV_AUTH_CLIENTID, LOGIN_DOT_GOV_URL } = useEnvironment();
  const configuration = getAuthConfig(AUTH_CLIENTID, LOGIN_DOT_GOV_AUTH_CLIENTID, LOGIN_DOT_GOV_URL, true);
  const service = useMemo(() => new VisAuthService(configuration), [configuration]);

  return service;
};

export default useVisAuthService;
